import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'
import ProfessionalBox from '../../components/general/homepage/ProfessionalBox'

import home_bgs from '../../assets/prof_bann.png'
import partners_bg from '../../assets/ww.png'

import project1 from '../../assets/project1.png'
import bozzy from '../../assets/bozzy.png'

import man_camera from '../../assets/man_camera.png'
import amaka from '../../assets/amaka.png'
import peter from '../../assets/peter.png'
import sophia from '../../assets/sophia.png'
import noah from '../../assets/noah.png'

const ProfessionalsSearch = () => {
	const [selected, setSelected] = useState('')

	let tags = ['cinematographer', 'Producer', 'Director', 'Photographer']

	let profss = [
		{
			image: project1,
			title: 'Actors',
		},
		{
			image: bozzy,
			title: 'Producers',
		},
		{
			image: project1,
			title: 'Cinematographers',
		},
		{
			image: project1,
			title: 'Make up artist',
		},
		{
			image: project1,
			title: 'Cinematographers',
		},
	]

	let settings = {
		dots: false,
		infinite: true,
		speed: 500,
		slidesToShow: 4,
		slidesToScroll: 1,
		arrows: true,
		autoplay: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: true,
				},
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					initialSlide: 2,
				},
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	}

	const profs = [
		{
			id: 1,
			image: amaka,
			name: 'Amaka Cross',
			role: 'Photographer/Cinematographer',
			no_of_projects: 105,
		},
		{
			id: 2,
			image: peter,
			name: 'Peter Parker',
			role: 'Cinematographer',
			no_of_projects: 15,
		},
		{
			id: 3,
			image: man_camera,
			name: 'David Bambam',
			role: 'Movie Director',
			no_of_projects: 1,
		},
		{
			id: 4,
			image: sophia,
			name: 'Sophia Stone',
			role: 'Graphics Effect Artisit',
			no_of_projects: 5,
		},
		{
			id: 5,
			image: noah,
			name: 'Noah Emeka',
			role: 'Photographer',
			no_of_projects: 32,
		},
		{
			id: 6,
			image: bozzy,
			name: 'Bozzy',
			role: 'Movie Director',
			no_of_projects: 0,
		},
	]

	return (
		<main className='prof_page'>
			<section
				className='prof_page_banner1'
				style={{ background: `url(${home_bgs})` }}
			>
				<div className='container'>
					<div className='d-flex prof_page_banner1_text'>
						<div>
							<h2>Professionals</h2>
							<form action=''>
								<div className='input-group mb-3'>
									<input
										type='email'
										className='form-control'
										placeholder='Search Professionals.......'
									/>
									<button className='btn' type='submit' id=''>
										Search
									</button>
								</div>
							</form>
							<p className='text-white'>
								<strong>Tags:</strong>{' '}
								{tags.map((e) => (
									<span className='tags'> {e} </span>
								))}
							</p>
						</div>
					</div>
				</div>
			</section>

			<section className='prof_page_info'>
				<div className='container'>
					<div className='row'>
						<div className='col-md-12'>
							<h3 className='section_header '>Popular Professional Services</h3>
						</div>
						<div className='col-md-12 mt-3 pl-5 pr-5'>
							<Slider {...settings}>
								{profss.map((e) => (
									<div className='prof_page_services_box'>
										<img src={e.image} alt='' />
										<div className='d-flex'>
											<p> {e.title} </p>
										</div>
									</div>
								))}
							</Slider>
						</div>
					</div>
				</div>
			</section>

			<section
				className='prof_page_lists'
				style={{ background: `url(${partners_bg})` }}
			>
				<div className='container'>
					<div className='row'>
						<div className='col-md-12'>
							<div className='homepage_projects_padbox_select float-right mb-5'>
								<select
									value={selected}
									onChange={(e) => setSelected(e.target.value)}
									className='form-select mb-3'
									style={{ width: '12rem' }}
								>
									<option value=''>All Categories</option>
									{/* <option value=''>All</option> */}
									<option value='photographers'>Photographers</option>
									<option value='writers'>Writers</option>
								</select>
							</div>
						</div>
					</div>
					<div className='homepage_projects_padbox'>
						<div className='row'>
							<ProfessionalBox profs={profs} />
						</div>
					</div>
				</div>
			</section>
		</main>
	)
}

export default ProfessionalsSearch
